import { render, staticRenderFns } from "./Sandbox.vue?vue&type=template&id=ab45a966&"
import script from "./Sandbox.vue?vue&type=script&lang=js&"
export * from "./Sandbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports